import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAction } from '../../classes/action';

export interface FindAPDFiltersModel {
    zipCode: string;
    lastName: string;
    city: string;
    state: string;
    country: string;
    mileRadius: number;
    pageSize: number;
}

export const defaultFindAPDFiltersModel: FindAPDFiltersModel = {
    zipCode: "",
    lastName: "",
    city: "",
    state: "",
    country: "",
    mileRadius: 5,
    pageSize: 10
}

export default function filtersReducer(state: FindAPDFiltersModel = defaultFindAPDFiltersModel, action: IAction) {
    switch (action.type) {
        case ActionType.UPDATE_TEXT_FILTER: {
            const filterName = action.value.filterName
            if (filterName === "lastName") {
                return assign({}, state, { lastName: action.value.filterValue });
            }
            else if (filterName === "zipCode")
                return assign({}, state, { zipCode: action.value.filterValue });
            else if (filterName === "city") {
                return assign({}, state, { city: action.value.filterValue });
            }
            else if (filterName === "state") {
                return assign({}, state, { state: action.value.filterValue });
            }
            else if (filterName === "country") {
                return assign({}, state, { country: action.value.filterValue });
            }
        }
        case ActionType.UPDATE_NUMBER_FILTER: {
            const filterName = action.value.filterName;

            if (filterName === "mileRadius") {
                return assign({}, state, { mileRadius: action.value.filterValue });
            }

            if (filterName === "pageSize") {
                return assign({}, state, { pageSize: action.value.filterValue });
            }
        }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/reducers/filters-reducer.ts